import React from "react";
import "./AcessoNegado.scss";
import WarningSign from "../../components/warningSign/index";

export default (props) => {

    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <WarningSign message="O ID do CPBS não pode ser vazio!" visible={false} />
                <div className={"main-div-home"}>

                    <h3>Acesso Negado</h3>
                    <p>Código do Recurso: {props.recursoId}</p>
                    <br />
                    <br />
                    <div className="div-contatos">
                        <h3>Contato:</h3>
                        <ul>
                            <li>Carlos Vieira - (85) 98135-4546</li>
                            <li>Ricardo Noronha - (48) 99968-2537</li>
                            <li>Dayanna Karina - (48) 99623-9701</li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* <Dashboard /> */}
        </React.Fragment>
    );
}
